import { TextField } from "@mui/material";
import InputSetting from "../inputSetting/InputSetting";
import {Button} from "@mui/material";

function CSInputs({
  components,
  changeRetries,
  changeSlotCount,
  changeBodyText,
  changeRecipient,
  changeSubject,
  addImage,
  setComponents,
  selectedLanguage,
  selectedComponentIndex,
  attributes
}) {

  function changeRetries2(value, name){
    if(value.trim() === '' || !isNaN(value)){
      changeRetries(value, name);
    }
  }

  return (
    <>
      {components[selectedComponentIndex].value.map((v, index) => {
        return (
          <InputSetting
            key={`${v.name}_${index}`}
            valueIndex={index}
            components={components}
            setComponents={setComponents}
            selectedComponentIndex={selectedComponentIndex}
            selectedLanguage={selectedLanguage}
            attributes={attributes}
          />
        );
      })}

      {components[selectedComponentIndex]?.retries !== undefined && (
        <div>
          <TextField
            id="retries"
            name="retries"
            label="Retries"
            value={components[selectedComponentIndex]?.retries}
            onChange={(e) => changeRetries2(e.target.value, "retries")}
            fullWidth
          />
        </div>
      )}

      {components[selectedComponentIndex]?.slotCount !== undefined && (
        <div>
          <TextField
            id="slotcount"
            name="slotcount"
            label="Slot Count"
            value={components[selectedComponentIndex]?.slotCount}
            onChange={(e) => changeSlotCount(e.target.value, "slotCount")}
            fullWidth
          />
        </div>
      )}

      {components[selectedComponentIndex]?.recipientEmail !== undefined && (
        
        <div>
          <TextField
            id="recipientEmail"
            name="recipientEmail"
            label="Recipient Email"
            value={components[selectedComponentIndex]?.recipientEmail}
            onChange={(e) => changeRecipient(e.target.value, "recipientEmail")}
            fullWidth
          />
          </div>
      )}

      {components[selectedComponentIndex]?.subjectText !== undefined && (   
          <div>
            <TextField
            //id das erste mal hier benutzt, sobald wo anders benutzt wird, wird das als unnessecary eingestuft.
              id="subjectText"
              name="subjectText"
              label="Subject Text"
              value={components[selectedComponentIndex]?.subjectText}
              onChange={(e) => changeSubject(e.target.value, "subjectText")}
              fullWidth
            />
          </div>
      )}
      {components[selectedComponentIndex]?.bodyText !== undefined && (   

          <div>
          <TextField
            id="bodyText"
            name="bodyText"
            label="Text Body"
            value={components[selectedComponentIndex]?.bodyText}
            onChange={(e) => changeBodyText(e.target.value, "bodyText")}
            fullWidth
          />
          </div>
          
        
      )}


      {components[selectedComponentIndex]?.name === "gallery" && (
        <Button variant="contained" fullWidth onClick={() => addImage("gallery", "Image URL")}>
          Add Image
        </Button>
      )}

    {components[selectedComponentIndex]?.name === "slotmachine" && (
        <Button variant="contained" fullWidth onClick={() => addImage("image", "Image URL")}>
          Add Image
        </Button>
      )}
    </>
  );
}

export default CSInputs;